export default __webpack_public_path__ + "9f98e974ccf1eb18f7465e7919efdeab.png";